<template>
  <header class="common-header">
    <h1 class="a11y-hidden">웨이브</h1>
    <div class="header-top">
      <h2 class="hd-title">{{ title }}</h2>
      <button v-if="isBackBtn" class="btn-back" type="button">
        <span class="a11y-hidden">뒤로 가기</span>
        <span class="icon-back" @click.prevent="onClickBack">
          <back-button />
        </span>
      </button>
      <button
        v-if="isCloseBtn"
        class="btn-close"
        type="button"
        @click.prevent="onClickClose"
      >
        <span class="a11y-hidden">나가기</span>
        <span class="icon-close">
          <CloseButtonIcon />
        </span>
      </button>
      <template v-if="isLive">
        <a href="#" class="btn-my-live" @click.prevent="goToReserveWatchFn">
          <span class="a11y-hidden">시청 예약 내역 바로가기</span>
          <span class="icon-my-live"><ScheduleIconOff /></span>
        </a>
        <a href="#" class="btn-schedule" @click.prevent="goToScheduleFn">
          <span class="a11y-hidden">전체 편성표 바로가기</span>
          <span class="icon-schedule"><schedule-button /></span>
        </a>
      </template>
    </div>
  </header>
</template>
<script>
  import BackButton from '@/assets/svg/common/ic_gnb_back_w.svg'
  import CloseButtonIcon from '@/assets/svg/common/ic_gnb_close_w.svg'
  import ScheduleIconOff from '@/assets/svg/common/ic-detail-alart-off.svg'
  import ScheduleButton from '@/assets/svg/common/ic-schd-cal-live.svg'
  export default {
    name: 'CommonHeader',
    components: {
      BackButton,
      CloseButtonIcon,
      ScheduleIconOff,
      ScheduleButton,
    },
    props: {
      title: {
        type: String,
      },
      backFn: {
        type: Function,
      },
      closeFn: {
        type: Function,
      },
      isBackBtn: {
        type: Boolean,
      },
      isCloseBtn: {
        type: Boolean,
      },
      goToReserveWatchFn: {
        type: Function,
      },
      goToScheduleFn: {
        type: Function,
      },
    },
    emits: ['click-back', 'click-close'],
    computed: {
      isLive() {
        return this.title === 'LIVE'
      },
    },
    methods: {
      onClickBack() {
        if (this.backFn) {
          this.backFn()
        }
        this.$emit('click-back')
      },
      onClickClose() {
        if (this.closeFn) {
          this.closeFn()
        }
        this.$emit('click-close')
      },
    },
  }
</script>
